import { ExportReportContentContainer } from '~/exportReport/exportReportContent.container';
import { ExportReportPrintPageWrapperComponent } from '~/exportReport/printPage/exportReportPrintPageWrapper.component';
import { useExportReportData } from '~/exportReport/useExportReportData';
import { useExportReportParams } from '~/exportReport/useExportReportParams';
import { useToolsStateExportReportSelector } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.selectors';

export const ExportReportPrintPageContainer = () => {
  const { isActive } = useToolsStateExportReportSelector();
  const { tableColumns } = useExportReportParams();
  const { getDemographicData, getDemographicLabel, isLoading } = useExportReportData({
    tableColumns,
  });

  if (!isActive) {
    return null;
  }

  return (
    <ExportReportPrintPageWrapperComponent isLoading={isLoading}>
      <ExportReportContentContainer
        tableColumns={tableColumns}
        getDemographicData={getDemographicData}
        getDemographicLabel={getDemographicLabel}
        // isLoading is intentionally not passed: no loader state is allowed in the printed content.
      />
    </ExportReportPrintPageWrapperComponent>
  );
};
